import { Router } from 'aurelia-router';
import { Account, Address, Customer } from '../../models/customer';
import { Business } from '../../models/business';
import { State } from '../../services/global-state';
import { PayrazrService } from '../../services/payrazr';
import { I18N } from 'aurelia-i18n';
import { mock, instance, verify, when, anything } from 'ts-mockito';
import { EventAggregator } from 'aurelia-event-aggregator';
import { ChangePassword } from './change-password';

describe('NewPortalWeb', () => {
	describe('pages', () => {
		describe('login-register', () => {
			describe('change-password', () => {
				let component: ChangePassword;
				let stubState: State;
				const mockCustomer: Customer = mock(Customer);
				const mockBusiness: Business = mock(Business);
				const mockRouter: Router = mock(Router);
				const mockPayrazrService: PayrazrService = mock(PayrazrService);
				const mockI18N: I18N = mock(I18N);
				const mockEventAggregator: EventAggregator = mock(EventAggregator);
				const mockAccount: Account = mock(Account);
				const mockAddress: Address = mock(Address);

				beforeEach(() => {
					stubState = new State(
						instance(mockI18N),
						instance(mockEventAggregator)
					);

					const i18next = {
						t: (a) => a
					};
					when(mockI18N.i18next).thenReturn(i18next);
					stubState.business = instance(mockBusiness);
					spyOn(i18next, 't').and.returnValue('localized');

					component = new ChangePassword(
						instance(mockPayrazrService),
						stubState,
						instance(mockRouter),
						instance(mockI18N)
					);

				});

				it('should initialize Change Password component', () => {
					expect(component).toBeTruthy();
				});

				describe('doUpdate()', () => {

					it('should update password and redirect to secure route', async () => {

						let customer = instance(mockCustomer);
						let account = instance(mockAccount);

						customer.messages = [];
						customer.paymentMethods = [];
						account.paymentPlans = [];
						customer.accounts = Array<Account>();
						customer.accounts.push(account);
						customer.primaryAddress = instance(mockAddress);
						customer.portfolios = null;

						component.model = {
							oldPassword: 'abc',
							newPassword: 'def'
						};
						stubState.customer.securitySettings = {
							username: 'xyz'
						};

						stubState.business.addCustomerPortfolios = () => { };

						spyOn(stubState.business, 'addCustomerPortfolios').and.callFake(() => {

						});

						when(mockPayrazrService.updatePassword(anything(), anything())).thenResolve({
							errors: null
						});

						when(mockPayrazrService.login(anything(), anything())).thenResolve({
							entity: {
								customer
							}
						});

						await component.doUpdate();

						verify(mockPayrazrService.updatePassword(anything(), anything())).called();
						verify(mockPayrazrService.login(anything(), anything())).called();

					});

				});

			});
		});
	});
});
